import { render } from "./LegacyCaseStudyFooter.vue?vue&type=template&id=1e11a7e8"
import script from "./LegacyCaseStudyFooter.vue?vue&type=script&lang=js"
export * from "./LegacyCaseStudyFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/LegacyCaseStudyFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e11a7e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e11a7e8', __exports__)) {
    api.reload('1e11a7e8', __exports__)
  }
  
  module.hot.accept("./LegacyCaseStudyFooter.vue?vue&type=template&id=1e11a7e8", () => {
    api.rerender('1e11a7e8', render)
  })

}


export default __exports__